export default "__VITE_ASSET__b2f182f4__"